import React, { useState } from 'react';
import { Button, FormControlLabel, Icon, IconButton, Switch } from '@material-ui/core';
import { ViewMode } from '../hooks/useSiteConfigurator';
import { useSiteContext } from '../SiteContext';
import { Link } from 'react-router-dom';
import SettingsDialog from '../plugins/components/SiteSettingsDialog';
const SiteEditorControls = () => {
    const { site, editing, setViewMode, toggleEdit } = useSiteContext();
    const [openDialog, setOpenDialog] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { component: Link, color: 'inherit', to: '.' },
            React.createElement(Icon, null, "home")),
        React.createElement("div", { className: 'flex' }),
        React.createElement(IconButton, { color: 'inherit', onClick: () => setViewMode(ViewMode.Fill) },
            React.createElement(Icon, null, "fullscreen")),
        React.createElement(IconButton, { color: 'inherit', onClick: () => setViewMode(ViewMode.Desktop) },
            React.createElement(Icon, null, "desktop_mac")),
        React.createElement(IconButton, { color: 'inherit', onClick: () => setViewMode(ViewMode.Tablet) },
            React.createElement(Icon, null, "tablet_mac")),
        React.createElement(IconButton, { color: 'inherit', onClick: () => setViewMode(ViewMode.Mobile) },
            React.createElement(Icon, null, "smartphone")),
        React.createElement("div", { className: 'flex' }),
        React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: Boolean(editing), onChange: () => toggleEdit(!editing), name: 'Edit Mode', color: 'secondary' }), label: editing ? 'Edit Mode' : 'View Mode' }),
        React.createElement(Button, { size: 'small', variant: 'outlined', color: 'inherit' }, "Status: Draft"),
        React.createElement(IconButton, { className: 'settings-button', color: 'inherit', onClick: () => {
                setOpenDialog(true);
            } },
            React.createElement(Icon, null, "settings")),
        openDialog && site && (React.createElement(SettingsDialog, { open: true, site: site, onCancel: () => setOpenDialog(false), onSubmit: () => setOpenDialog(false) }))));
};
export default SiteEditorControls;
//# sourceMappingURL=SiteEditorControls.js.map